// @flow

import * as React from 'react';

export const ActionBarStateContext = React.createContext(
  {}, // default value
);

type DropdownValue = {
  text: string,
  valye: string,
};

type Props = {
  children: React.Node,
  months: [DropdownValue],
  territorialStates: [DropdownValue],
  selectedState: string,
  selectedMonth: string,
};

type State = {
  territorialState: string,
  month: string,
};

export const ActionBarStateConsumer = ActionBarStateContext.Consumer;

export class ActionBarStateProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      territorialState: props.selectedState,
      month: props.selectedMonth,
    };
  }

  onChangeTerritorialState = (value: string) => {
    this.setState({
      territorialState: value,
    });
  };

  onChangeMonth = (value: string) => {
    this.setState({
      month: value,
    });
  };

  render() {
    return (
      <ActionBarStateContext.Provider
        value={{
          territorialState: this.state.territorialState,
          month: this.state.month,
          onChangeTerritorialState: this.onChangeTerritorialState,
          onChangeMonth: this.onChangeMonth,
          months: this.props.months,
          territorialStates: this.props.territorialStates,
        }}
      >
        {this.props.children}
      </ActionBarStateContext.Provider>
    );
  }
}
